// ── HubSpot readiness checks for a turnover ──────────────────────────────────
// One rule set for both places that check a deal before (New Turnover in
// Turnovers.jsx) and during (Cover Sheet) a turnover — they had drifted.
//
// The owner and the contract holder are separate roles (2026-09-23):
//   • Owner — the client / property owner; its company name is the Cover
//     Sheet's client. Label: exactly "Owner".
//   • Contract Holder — whoever CleanSpace's contract is with: a GC, a CM, or
//     the owner itself. Label: "Contract Holder".
// Both labels are required. When CleanSpace contracts directly with the
// owner, the same company carries both labels. Previously one check passed
// for any of Owner / Contract Holder / GC / prime contractor, so a deal with
// only its owner labeled went through with no contract holder recorded.
//
// Inputs are lowercase-able label strings (one per association label).

export const OWNER_LABEL = "owner";
export const CONTRACT_HOLDER_LABEL = "contract holder";
export const BILLING_LABELS = ["billing contact", "billing", "accounts payable", "ap contact"];
export const JOBSITE_LABELS = ["jobsite address", "job site address", "jobsite", "job site"];

const norm = (labels) => (labels || []).filter(Boolean).map(l => String(l).trim().toLowerCase());

export function hubspotReadinessChecks({ companyLabels = [], contactLabels = [], companyCount = 0, lineItemCount = 0 } = {}) {
  const co = norm(companyLabels);
  const ct = norm(contactLabels);
  return [
    { key: "company", label: "Company exists", pass: companyCount > 0,
      failMsg: "No company associated — add the owner (and the contract holder, if different) to this deal in HubSpot" },
    { key: "billing", label: "Billing contact assigned", pass: ct.some(l => BILLING_LABELS.some(b => l.includes(b))),
      failMsg: "No billing contact — label a contact as Billing Contact in HubSpot" },
    { key: "owner", label: "Owner company (client on the cover sheet)", pass: co.includes(OWNER_LABEL),
      failMsg: `No "Owner" company — label the client / property owner's company Owner in HubSpot` },
    { key: "contract_holder", label: "Contract Holder company", pass: co.includes(CONTRACT_HOLDER_LABEL),
      failMsg: `No "Contract Holder" company — label the company CleanSpace's contract is with (GC, CM, or the owner itself) Contract Holder in HubSpot. If it is the owner, that company carries both labels` },
    { key: "jobsite", label: "Jobsite Address assigned", pass: co.some(l => JOBSITE_LABELS.some(j => l.includes(j))),
      failMsg: "No jobsite address — label a company as Jobsite Address in HubSpot" },
    { key: "lineitems", label: "Line items exist", pass: lineItemCount > 0,
      failMsg: "No line items — add at least one release to this deal in HubSpot" },
  ];
}
